import { useEffect, useState, type ReactNode } from "react";
import { classNames } from "./internal/class-names";

export function EntityPhoto(props: {
  readonly className?: string;
  readonly fallback: ReactNode;
  readonly label: string;
  readonly size?: "small" | "large";
  readonly src?: string | null;
}): ReactNode {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [props.src]);
  const showImage = Boolean(props.src) && !failed;
  return (
    <span className={classNames("thw-entity-photo", `thw-entity-photo--${props.size ?? "small"}`, props.className)}>
      {showImage ? (
        <img alt={props.label} onError={() => setFailed(true)} src={props.src ?? undefined} />
      ) : (
        <>
          <span aria-hidden="true" className="thw-entity-photo__fallback">{props.fallback}</span>
          <span className="sr-only">{props.label}</span>
        </>
      )}
    </span>
  );
}
